// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import type { RootState, CategoriesSlice } from "redux/types";
import { Category } from "interfaces/searchPage/category";

// Defaults
export const initialState: CategoriesSlice = {
	categories: []
};

// Slice
export const categoriesSlice = createSlice({
	name: "CATEGORIES",
	initialState,
	reducers: {
		setCategories: (state, action: PayloadAction<Category[]>) => {
			return { ...state, categories: action.payload };
		}
	}
});

// Actions
export const { setCategories } = categoriesSlice.actions;

// Selector
export const categoriesSelector = (state: RootState): Category[] => state.categories.categories;

// Reducers
export default categoriesSlice.reducer;
